module.exports = __webpack_public_path__ + "static/media/icon-plus.b2946e5a.png";